import React from 'react';
import { addMonths, parseISO, toDate } from 'date-fns';
import { safeAddDays } from './utils';

interface Args {
	currentMonthISO: string;
	isMonthExist: (d: Date) => boolean;
	onMonthChange?: (d: Date) => void;
	onPricesEnd?: (d: Date, direction: 'next' | 'prev') => void;
	setOpenedDate: React.Dispatch<React.SetStateAction<Date>>;
}

export const useSliderHandlers = ({
	currentMonthISO,
	isMonthExist,
	onMonthChange,
	onPricesEnd,
	setOpenedDate
}: Args) => {
	const onItemCentered = React.useCallback(
		(startItemIndex: number, minDate: Date) => {
			const day = safeAddDays(minDate, startItemIndex);
			setOpenedDate(day);
		},
		[setOpenedDate]
	);

	const sliderArrowHandler = React.useCallback(
		(direction: 'next' | 'prev', _startItemIndex: number, _itemsCount: number, itemsOutsideBoundary: number) => {
			if (itemsOutsideBoundary !== 0) {
				return;
			}

			const nextMonth = addMonths(parseISO(currentMonthISO), direction === 'next' ? 1 : -1);

			if (!isMonthExist(nextMonth)) {
				onPricesEnd?.(addMonths(nextMonth, -11), direction);
			}
			onMonthChange && onMonthChange(nextMonth);
			setOpenedDate(toDate(nextMonth));
		},
		[currentMonthISO, isMonthExist, onMonthChange, onPricesEnd, setOpenedDate]
	);

	const mobileArrowHandler = React.useCallback(
		(startItemIndex: number, minDate: Date) => {
			const date = safeAddDays(minDate, startItemIndex);
			setOpenedDate(toDate(date));
		},
		[setOpenedDate]
	);

	return { onItemCentered, sliderArrowHandler, mobileArrowHandler };
};
